import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css"
import { FontAwesomeIcon } from './plugins/font-awesome'
import { ServerTable } from 'v-tables-3'
import vSelect from 'vue-select'
import { tableteme } from './utils/table-theme'
import VueExcelXlsx from "vue-excel-xlsx";

import "vue-select/dist/vue-select.css";

createApp(App)
  .use(router)
  .use(store)
  .use(ServerTable, {}, tableteme)
  .use(VueExcelXlsx)
  .component('v-select', vSelect)
  .component("font-awesome-icon", FontAwesomeIcon)
  .mount("#app");


import "bootstrap/dist/js/bootstrap.js"